var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderProducer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 23a1 1 0 1 0 2 0H3Zm4-7.5-.394-.92-.027.012-.026.014L7 15.5Zm2.5-1.262.513.859-.513-.859Zm6.892.132.515-.858-.515.858Zm4.257 4.943a1 1 0 0 0 1.937-.498l-1.937.498ZM5 23c0-1.012.004-2.389.342-3.685.335-1.284.96-2.348 2.105-2.92l-.894-1.79c-1.855.928-2.73 2.614-3.146 4.205C2.995 20.39 3 22.012 3 23h2Zm2.394-6.58a23.866 23.866 0 0 0 2.619-1.323L8.987 13.38c-.804.48-1.772.94-2.38 1.2l.787 1.84Zm2.619-1.323a9.62 9.62 0 0 0 1.062-.72c.285-.23.627-.545.82-.93l-1.79-.894c.011-.021-.04.07-.28.262-.215.171-.502.364-.838.565l1.026 1.717Zm9.434-.491c-.526-.264-1.1-.49-1.566-.675-.514-.203-.826-.33-.974-.419l-1.03 1.715c.326.196.837.394 1.268.564.48.19.973.386 1.408.603l.894-1.788Zm-2.54-1.094c-.737-.442-.804-.586-.78-.549 0 .003.036.078-.035-.096a1.697 1.697 0 0 0-.385-.574l-1.414 1.414c.001.001-.011-.011-.028-.037-.016-.025-.024-.045-.023-.042l.013.034.033.084c.031.074.074.167.139.271.25.403.689.753 1.45 1.21l1.03-1.715Zm5.679 5.302c-.422-1.638-1.303-3.29-3.139-4.208l-.894 1.788c1.132.566 1.757 1.602 2.096 2.92l1.937-.5Z",
    fill: "#323657"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8a4 4 0 0 1 8 0v1a4 4 0 0 1-8 0V8Z",
    stroke: "#323657",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.5c-1.167.833-4.9 2-6.5 0C4 8.833 5.802 7.494 7 4.5c1-2.5 3-3 4-3s2 1 1 2.5",
    stroke: "#323657",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.5c1 1.333 3.8 3.6 7 2",
    stroke: "#323657",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20.5h10m0 0L15.083 18M18 20.5 15.083 23",
    stroke: "#323657",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderProducer);
export default __webpack_public_path__ + "static/media/header-producer.d1fcb161e0243c1ba8d8069b5a12eb22.svg";
export { ForwardRef as ReactComponent };